const TIME_ZONE = 'Europe/Oslo';

const baseFormatter = new Intl.DateTimeFormat('en-GB', {
  timeZone: TIME_ZONE,
  hour12: false,
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  timeZoneName: 'shortOffset'
});

const dateFormatter = new Intl.DateTimeFormat('en-GB', {
  timeZone: TIME_ZONE,
  hour12: false,
  year: 'numeric',
  month: '2-digit',
  day: '2-digit'
});

const weekdayFormatter = new Intl.DateTimeFormat('en-GB', {
  timeZone: TIME_ZONE,
  weekday: 'short'
});

function partsToObject(parts) {
  return parts.reduce((acc, part) => {
    if (part.type === 'literal') return acc;
    acc[part.type] = part.value;
    return acc;
  }, {});
}

export function zonedStartOfDay(year, month, day) {
  const base = new Date(Date.UTC(year, month - 1, day, 0, 0, 0));
  const parts = partsToObject(baseFormatter.formatToParts(base));
  const hour = Number(parts.hour || '0');
  const minute = Number(parts.minute || '0');
  const second = Number(parts.second || '0');
  const adjustmentMinutes = hour * 60 + minute + second / 60;
  return new Date(base.getTime() - adjustmentMinutes * 60000);
}

export function getZonedDateParts(date) {
  const parts = partsToObject(dateFormatter.formatToParts(date));
  return {
    year: Number(parts.year || '0'),
    month: Number(parts.month || '0'),
    day: Number(parts.day || '0')
  };
}

export function getZonedWeekdayIndex(date) {
  const label = weekdayFormatter.format(date).slice(0, 3);
  const weekDays = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  const index = weekDays.indexOf(label);
  return index === -1 ? 0 : index;
}

export function moveByDays(date, days) {
  if (!Number.isFinite(days) || days === 0) {
    return date;
  }
  const currentParts = getZonedDateParts(date);
  const guess = new Date(Date.UTC(currentParts.year, currentParts.month - 1, currentParts.day + days));
  const nextParts = getZonedDateParts(guess);
  return zonedStartOfDay(nextParts.year, nextParts.month, nextParts.day);
}

export function formatDateKey(date) {
  const parts = getZonedDateParts(date);
  const month = String(parts.month).padStart(2, '0');
  const day = String(parts.day).padStart(2, '0');
  return `${parts.year}-${month}-${day}`;
}

export function getOsloToday() {
  const parts = getZonedDateParts(new Date());
  return zonedStartOfDay(parts.year, parts.month, parts.day);
}

export function getTimeZone() {
  return TIME_ZONE;
}
